let loaded = document.readyState === 'complete';

if (!loaded) {
    window.addEventListener(
        'load',
        () => { loaded = true; },
        { once: true }
    );
}

/**
 * Check if the page load state is complete
 * @returns {boolean}
 */
export default () => loaded;
